import BaseItemView from 'app/src/views/base/BaseItemView';
import Format from 'app/src/data/Format';
import Decimal from 'app/src/data/base/Decimal';
import paymentTotalViewTemplate from './templates/payment-total-view.hbs';

const _Events = {
  REMOVE_DEPOSITS_CLICKED: 'remove:deposits:clicked',
};

// configure
let View = BaseItemView.extend({
  template: paymentTotalViewTemplate,

  ui: {
    saleTotal: '#sale_total',
    paymentsTotal: '#payments_total2',
    balance: '#sale_balance',
    deposit: '#account_deposit_row',
    depositTitle: '#account_deposit_title',
    depositRefund: '#account_withdraw_row',
    depositAmount: '#account_deposit_cell',
    depositRefundAmount: '#account_withdraw_cell',
    removeDepositsButton: '#totalsRemoveDepositButton',
    tipTotal: '#tip_total',
  },

  triggers: {
    'click @ui.removeDepositsButton': _Events.REMOVE_DEPOSITS_CLICKED,
  },
});

// define
export default class PaymentTotalView extends View {
  static get Event() {
    return _Events;
  }

  /**
   * Update the Sale Total
   *
   * @param amount {Decimal} The total Sale amount
   */
  updateSaleTotal(amount) {
    this.ui.saleTotal.text(Format.formatMoney(amount));
  }

  updateTipAmount(amount) {
    this.ui.tipTotal.text(Format.formatMoney(amount));
  }

  /**
   * Update the displayed payments total.
   *
   * @param amount {Decimal}  The total payments on a sale
   */
  updateTotal(amount) {
    this.ui.paymentsTotal.text(Format.formatMoney(amount));
  }

  /**
   * Updates the balance displayed in the view.  It will show negative balances
   * as zero.
   *
   * @param amount {Decimal}  The balance for a sale
   */
  updateBalance(amount) {
    if (amount.isZero()) {
      this.ui.balance.removeClass('red').addClass('green');
    } else {
      this.ui.balance.removeClass('green').addClass('red');
    }

    this.ui.balance.text(Format.formatMoney(amount));
  }

  /**
   * Shows or hides the deposit UI
   *
   * @param {boolean} show    When true will show the UI
   */
  showDeposits(show = true) {
    if (show) {
      this.ui.deposit.show();
    } else {
      this.ui.deposit.hide();
    }
  }

  /**
   * Sets the deposit amount
   *
   * @param {Decimal} amount  The deposit amount
   */
  setDepositAmount(amount) {
    this.ui.depositAmount.text(Format.formatMoney(amount));
  }

  /**
   * Shows or hides the deposit UI
   *
   * @param {boolean} show    When true will show the UI
   */
  showDepositRefunds(show = true) {
    if (show) {
      this.ui.depositRefund.show();
    } else {
      this.ui.depositRefund.hide();
    }
  }

  /**
   * Sets the deposit amount
   *
   * @param {Decimal} amount  The deposit amount
   */
  setDepositRefundAmount(amount) {
    this.ui.depositRefundAmount.text(Format.formatMoney(amount));
  }

  /**
   * Sets the deposit title
   *
   * @param {string} title    The title to use for the deposit total
   */
  setDepositTitle(title) {
    this.ui.depositTitle.text(title);
  }
}
